import { IAddress } from '@r1-frontend/shared/types/IAddress';

import { EContactDetailTypes, TFillAddressAction } from '../index';

export const fillAddressAction = (address: IAddress): TFillAddressAction => {
    return ({
        type: EContactDetailTypes.FILL_ADDRESS,
        payload: {
            editedAddressData: address,
        },
    });
};
